// File: store/releases.js
// Purpose: State store for the Releases view (curated upcoming movies).
// Notes: Populated by `fetchUpcomingCurated` and split by year in the router.
export default {
  header: "Upcoming Movie Releases",
  view: "Releases",
  movies2026: [],
  movies2027: [],
  popular: []
};
